
//we should really just be setting the company id/name here,but for now, and because we have STRY0045127,
// just going to set the link as well, rather then looking up the story

export function SetCompanySelection(company: string, loginLink: string){
    sessionStorage.setItem("company-selection", company);
    sessionStorage.setItem("company-selection-link", loginLink);
}
export function getCompanySelection(): {company: string | null, loginLink: string | null}{
    const company = sessionStorage.getItem("company-selection");
    const loginLink = sessionStorage.getItem("company-selection-link");
    return {
        company,
        loginLink
    };
}